import { handlePaymentOrder, cleanupIdempotencyKey } from './Common';

import { SplunkReporter } from 'reporting/splunk/SplunkReporter';
import { saleSelectors } from 'store/sale/selectors';
import { RootState } from 'store/store';
import { AdyenPaymentMethod, PbcWalletInfo } from 'types/BusinessLogic';

const logger = 'businessLogic/Payment/PayByCard';
const splunkReporter = SplunkReporter.getInstance();
export const handlePbcOrder = async (
  state: RootState,
  walletInfo: PbcWalletInfo,
  payorEmail: string,
  isSavePaymentMethodChecked: boolean
) => {
  const {
    companyInfo: { region: country },
    payment: { amount },
    insight: { token },
  } = state;
  const paymentMethodType =
    walletInfo?.walletId === 'AddCard'
      ? AdyenPaymentMethod.PAYBYCARD
      : AdyenPaymentMethod.PAYBYCARD_WALLET;

  splunkReporter.contextual({
    logInfo: { logLevel: 'info', logger },
    event: 'pay',
    action: 'createOrder',
    activityInfo: {
      paymentMethod: paymentMethodType,
      amount,
      country,
      hasCvc: !!walletInfo?.cvc,
    },
  });

  const payorName = saleSelectors.customerNameSelector(state.sale);
  const payorEmailAddress = saleSelectors.toEmailsSelector(state.sale)[0] || payorEmail;
  const paymentDetails = {
    payorName,
    payorEmailAddress,
    country,
    walletInfo,
    isSavePaymentMethodChecked,
  };
  const result = await handlePaymentOrder(state, paymentMethodType, paymentDetails);

  const payByCardResponse = result.payByCardResponse;

  if (payByCardResponse?.redirectUrl) {
    return {
      type: 'redirect',
      redirectUrl: payByCardResponse.redirectUrl,
      orderId: result.orderId,
      status: result.status,
    };
  } else {
    cleanupIdempotencyKey(token, amount);
    return {
      type: 'immediate',
      orderId: result.orderId,
      paymentResponse: payByCardResponse?.paymentResponse,
    };
  }
};
